<template>
  <v-card :loading="loading" flat min-height="300" style="overscroll-behavior: contain">
    <v-tabs v-model="tabs" :show-arrows="false" color="primary">
      <v-tab>
        <v-icon right>mdi-broadcast</v-icon>
        ویدئو آماده
      </v-tab>

      <v-tab>
        <v-icon right>mdi-image-area-close</v-icon>
        گالری ویدئو
      </v-tab>

      <v-tab>
        <v-icon right>mdi-link-plus</v-icon>
        لینک
      </v-tab>

      <v-tab>
        <v-icon right>mdi-cloud-upload-outline</v-icon>
        آپلود ویدئو
      </v-tab>
    </v-tabs>

    <v-divider class="mt-0"/>

    <v-tabs-items v-model="tabs">
      <v-tab-item>
        <v-row v-if="!!defaultVideos" class="pa-3 custom-scrollbar" no-gutters
               style="max-height: calc(90vh - 250px);overflow-y: auto;">
          <v-col class="pb-2" cols="12">
            <v-text-field v-model="search.defaults" :loading="loading" append-icon="mdi-magnify"
                          clear-icon="mdi-close-circle-outline" clearable dense hide-details label="جستجو" outlined
                          @click:append="handleSearch(true)" @keydown.enter="handleSearch(true)"
                          @click:clear="clearSearch(false)"/>
          </v-col>

          <template v-for="defVideo in defaultVideos.data">
            <v-col :key="defVideo.id"
                   :class="value.images.findIndex(item => item.id === defVideo.id) > -1
                   ? 'border border-2 border-success'
                   : 'border'"
                   :data-img="defVideo.id" class="pa-1" cols="12" md="4" @click="select(defVideo)">
              <video-selector-card :value="value.images.findIndex(item => item.id === defVideo.id) > -1"
                                   :video="defVideo"/>
            </v-col>
          </template>

          <v-col cols="12">
            <v-card v-if="!loading && !defIsLastPage && tabs === 0" v-intersect="onDefaultIntersect" flat>
              <v-progress-circular color="primary" indeterminate size="35" width="5"/>
            </v-card>
          </v-col>
        </v-row>
      </v-tab-item>

      <v-tab-item>
        <v-row class="pa-3 custom-scrollbar" no-gutters
               style="max-height: calc(90vh - 300px);overflow-y: auto;">
          <v-col class="pb-2" cols="12">
            <v-text-field v-model="search.user" :loading="loading" append-icon="mdi-magnify"
                          clear-icon="mdi-close-circle-outline" clearable dense hide-details label="جستجو" outlined
                          @click:append="handleSearch(false)" @keydown.enter="handleSearch(false)"
                          @click:clear="clearSearch(true)"/>
          </v-col>

          <v-col v-for="(video, j) in userVideos.data" :key="video.id"
                 :class="value.images.findIndex(item => item.id === video.id) > -1 ? 'border border-2 border-success' : ''"
                 :data-img="video.id" class="pa-1" cols="12" md="4" @click="select(video)">
            <video-selector-card :value="value.images.findIndex(item => item.id === video.id) > -1"
                                 :video="video" show-delete @delete="deleteVideo($event)"/>
          </v-col>

          <v-col cols="12">
            <v-card v-if="!loading && !isLastPage && tabs === 1" v-intersect="onIntersect">
              <v-progress-circular color="primary" indeterminate size="35" width="5"/>
            </v-card>
          </v-col>
        </v-row>

        <v-card v-if="!loading && (!userVideos.data || !userVideos.data.length)" flat
                style="max-height: calc(90vh - 250px);overflow-y: auto;" width="100%">
          <v-card-title class="text-center justify-center" v-text="'ویدئویی پیدا نشد!'"/>
          <v-card-subtitle class="text-center">
            برای افزودن فایل از قسمت آپلود ویدئو استفاده نمایید
          </v-card-subtitle>
        </v-card>
      </v-tab-item>

      <v-tab-item>
        <video-by-link :images.sync="computedValue.images" @fetch="reloadByUpload"/>
      </v-tab-item>

      <v-tab-item>
        <video-upload-handler @fetch="reloadByUpload"/>
      </v-tab-item>
    </v-tabs-items>
  </v-card>
</template>

<script>
import VideoSelectorCard from "@/view/content/pickers/uploadCenter/videoUploader/videoSelectorCard.vue";
import VideoByLink from "@/view/content/pickers/uploadCenter/videoUploader/videoByLink.vue";
import VideoUploadHandler from "@/view/content/pickers/uploadCenter/videoUploader/videoUploadHandler.vue";
import {qrAxios} from "@/main";

export default {
  name: "videoUploader",

  components: {VideoSelectorCard, VideoByLink, VideoUploadHandler},

  props: {
    singleGallery: Boolean,
    value: [Array, String, Object],
  },

  data() {
    return {
      defaultVideos: {
        data: []
      },
      defIsLastPage: false,
      defPage: 1,
      errors: '',
      filesModel: null,
      getError: false,
      isIntersecting: false,
      isLastPage: false,
      loading: false,
      page: 1,
      search: {
        defaults: '',
        user: '',
      },
      tabs: 0,
      upLoading: false,
      userVideos: {
        data: []
      }
    }
  },

  mounted() {
    this.getDefaultVideos()
  },

  computed: {
    computedValue: {
      get() {
        return this.value
      },
      set(val) {
        this.$emit('input', val)
      }
    }
  },

  methods: {
    fetch() {
      this.page = 1
      this.tabs = 1
      this.$nextTick(() => {
        this.getUserVideos()
      })
    },
    getDefaultVideos(s) {
      this.loading = true

      let params = {
        default: 1,
        page: this.defPage,
      }

      if (!!s) params.search = s

      this.$nextTick(() => {
        qrAxios.get('/user/aparat', {
          params: params
        })
          .then(({data}) => {
            let lastImg = this.defaultVideos?.data || []
            let temp = data.data
            temp.data = lastImg.concat(temp.data)
            this.defaultVideos = temp

            this.defIsLastPage = !data.data.next_page_url
            this.defPage++
          })
          .catch(({response}) => console.log('error in get default aparat videos: ', response))
          .finally(() => this.loading = false);
      })
    },
    getUserVideos(s) {
      this.loading = true

      let params = {
        page: this.page,
        dir: 'desc'
      }

      if (!!s) params.search = s

      qrAxios.get('/user/aparat', {
        params: params
      })
        .then(({data}) => {
          let lastImg = this.userVideos?.data || []
          let temp = data.data
          temp.data = lastImg.concat(temp.data)
          this.userVideos = temp

          this.isLastPage = !data.data.next_page_url
          this.page++
        })
        .catch(({response}) => console.log('error in get user aparat videos: ', response))
        .finally(() => this.loading = false)
    },
    select(image) {
      if (!this.value.images.find(item => item.id === image.id))
        if (this.onePic) {
          this.$emit('update:field', image.full_path)
          this.computedValue.images = []
          this.computedValue.images[0] = {
            name: image.title,
            title: '',
            url: image.full_path,
            description: '',
            link: '',
            id: image.id
          }
        } else {
          this.computedValue.images.push({
            name: image.title,
            title: '',
            file_link: image.full_path || image.file_link,
            description: '',
            link: '',
            id: image.id
          })
        }
      else {
        this.deleteSelectedImage(image)
      }
    },
    deleteSelectedImage(image) {
      let index = this.computedValue.images.findIndex(item => !!item.id ? item.id === image.id : item.url === image.url)
      this.computedValue.images.splice(index, 1);
    },
    onDefaultIntersect(entries, observer) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting
      this.$nextTick(() => {
        if ((this.isIntersecting || !this.defaultVideos.data) && !this.defIsLastPage) {
          this.getDefaultVideos()
        }
      })
    },
    onIntersect(entries, observer) {
      // More information about these options
      // is located here: https://developer.mozilla.org/en-US/docs/Web/API/Intersection_Observer_API
      this.isIntersecting = entries[0].isIntersecting
      this.$nextTick(() => {
        if ((this.isIntersecting || !this.userVideos.data) && !this.isLastPage)
          this.getUserVideos()
      })
    },
    deleteVideo(id) {
      this.loading = true

      qrAxios.delete(`/user/aparat/${id}`)
        .then(({data}) => {
          this.$toast.success('با موفقیت حذف شد.');
          switch (this.tabs) {
            case 0:
              this.defIsLastPage = false;
              this.defPage = 1;
              this.defaultVideos = {data: []};
              break;
            case 1:
              this.isLastPage = false;
              this.page = 1;
              this.userVideos = {data: []};
              break;
          }
        })
        .catch(({response}) => console.log('delete has error: ', response))
        .finally(() => this.loading = false)
    },
    reloadByUpload() {
      this.userVideos = {
        data: []
      }
      this.isLastPage = false
      this.page = 1
      this.$nextTick(() => {
        this.tabs = 1
      })
    },
    handleSearch(getDefault = false, reset = false) {
      if (getDefault) {
        if (this.search.defaults.length >= 3) {
          this.defIsLastPage = false
          this.defaultVideos = {data: []}
          this.defPage = 1
          this.$nextTick(() => {
            this.getDefaultVideos(this.search.defaults)
          })
        }
      } else {
        if (this.search.user.length >= 3) {
          this.isLastPage = false
          this.userVideos = {data: []}
          this.page = 1
          this.$nextTick(() => {
            this.getUserVideos(this.search.user)
          })
        }
      }
    },
    clearSearch(defaults = false) {
      if (defaults) {
        this.search.defaults = ''
        this.defIsLastPage = false;
        this.defaultVideos = {data: []};
        this.defPage = 1;
        this.$nextTick(() => {
          setTimeout(() => {
            this.getDefaultVideos()
          }, 2000)
        });
      } else {
        this.search.user = ''
        this.isLastPage = false
        this.userVideos = {data: []}
        this.page = 1
        this.$nextTick(() => {
          setTimeout(() => {
            this.getUserVideos()
          }, 500)
        })
      }
    }
  }
}
</script>

<style scoped>
@media screen and (max-width: 600px) {
  .v-tabs >>> .v-slide-group__prev {
    display: none !important;
  }
}
</style>